import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Logger from '@sm360/logger-sentry';
import { ConfigsService } from '@sm360/widget-commons-core-services';

import './MessageBox.scss';

class MessageBox extends Component {
    constructor(props) {
        super(props);

        this.state = { show: true };

        this.getClassNamesFromLevel = this.getClassNamesFromLevel.bind(this);
        this.handleDismiss = this.handleDismiss.bind(this);

        this.logger = new Logger(this.constructor.displayName, ConfigsService.getLoggerContext());
    }

    getClassNamesFromLevel() {
        if (this.props.level === 'success') {
            return {
                wrapper: `message-box-wrapper message-box-has-${this.props.level}-background`,
                icon: 'icon-Crochet',
            };
        }
        if (this.props.level === 'error') {
            return {
                wrapper: `message-box-wrapper message-box-has-${this.props.level}-background`,
                icon: 'icon-x-config',
            };
        }
        return null;
    }

    handleDismiss() {
        if (this.state.show) {
            this.setState({ show: false });
        }
    }

    render() {
        if (!this.state.show) {
            return null;
        }
        const classNames = this.getClassNamesFromLevel();
        if (!classNames) {
            this.logger.error(
                `Cannot render component because the level specified (${this.props.level}) does not exists.`
            );
            return null;
        }
        const props = { className: classNames.wrapper };
        if (this.props.dismissOnClick) {
            props.onClick = this.handleDismiss;
            props.style = { cursor: 'pointer' };
        }
        return (
            <div {...props}>
                <icon className={classNames.icon} /> {this.props.message}
            </div>
        );
    }
}

MessageBox.defaultProps = {
    dismissOnClick: false,
};

MessageBox.propTypes = {
    level: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    dismissOnClick: PropTypes.bool,
};

MessageBox.displayName = 'MessageBox';

export default MessageBox;
